import React from 'react';
import classNames from 'classnames';

const Label = ({label, date, isHighlighted}) => {
    const labelClasses = classNames('CheckInCheckOut__label', {
        'CheckInCheckOut__label--selected': isHighlighted
    });

    return (
        <span className={labelClasses}>{ date ? date : label }</span>
    );
};

export default Label;